import React from "react";
import { Star } from "lucide-react";

const clubs = [
  "Padel Milano",
  "Court Barcelona",
  "PadelClub Dubai",
  "London Padel",
  "Lisboa Padel",
  "Roma Padel Pro",
  "Miami Padel",
  "Berlin Court",
];

const quotes = [
  {
    text: "Rallie replaced our clipboard. We run 24-player Americanos on Sunday mornings without a single manual calculation.",
    author: "Alex Moretti",
    role: "Club Manager · Padel Milano",
  },
  {
    text: "The live scoring is faster than any app I have used. My players actually enjoy watching the score update in real time.",
    author: "Sara Lopez",
    role: "Head Coach · Court Barcelona",
  },
  {
    text: "Career stats keep me coming back. I know exactly who I have played, how often I win and where I can improve.",
    author: "Marco Rossi",
    role: "Player · Rome",
  },
];

export default function Testimonials() {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="relative py-20 md:py-24 border-t border-neutral-900"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-center mb-14">
          <div className="text-xs uppercase tracking-widest text-[#D4F34A] mb-4">
            Social proof
          </div>
          <h2
            data-testid="testimonials-heading"
            className="font-display uppercase tracking-tight text-4xl md:text-6xl leading-[0.9]"
          >
            Trusted by padel
            <br />
            communities worldwide.
          </h2>
        </div>

        {/* Club logos */}
        <div
          data-testid="trusted-logos"
          className="grid grid-cols-2 sm:grid-cols-4 gap-y-8 gap-x-6 items-center mb-20 opacity-80"
        >
          {clubs.map((c, i) => (
            <div
              key={c}
              data-testid={`club-logo-${i}`}
              className="flex items-center justify-center gap-2 text-neutral-500 hover:text-white transition"
            >
              <span className="w-2 h-2 rounded-full bg-[#D4F34A]" />
              <span className="font-display uppercase text-lg tracking-tight">
                {c}
              </span>
            </div>
          ))}
        </div>

        {/* Quotes */}
        <div className="grid md:grid-cols-3 gap-4">
          {quotes.map((q, i) => (
            <div
              key={q.author}
              data-testid={`testimonial-${i}`}
              className="border border-neutral-900 p-6 md:p-8 hover:border-[#D4F34A] transition-colors bg-neutral-950"
            >
              <div className="flex gap-1 text-[#D4F34A] mb-4">
                {[...Array(5)].map((_, j) => (
                  <Star key={j} size={14} fill="currentColor" strokeWidth={0} />
                ))}
              </div>
              <p className="text-base md:text-lg text-white leading-snug">
                “{q.text}”
              </p>
              <div className="mt-6 pt-4 border-t border-neutral-900">
                <div className="font-display uppercase text-sm">{q.author}</div>
                <div className="text-[11px] uppercase tracking-widest text-neutral-500 mt-1">
                  {q.role}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
